import React, { useState, useEffect } from "react";
import { Tab, Tabs } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom"; 
import TabPanel from "../../components/common/tabpannel/Tabpannel";
import Accountoverview from "./accountoverview/Accountoverview";
import TransactionTab from "./transaction/Transactiontab";
import BudgettingTab from "./budgetting/BudgettingTab";
import ReportTab from "./reports/Reportstab";

const Myaccount = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate(); 
  const location = useLocation(); 

  useEffect(() => {
    if (location.pathname === "/organizefinance/accountoverview") {
      setSelectedTab(0);
    } else if (location.pathname === "/organizefinance/transaction") {
      setSelectedTab(1);
    } else if (location.pathname === "/organizefinance/budgetting") {
      setSelectedTab(2);
    } else if (location.pathname === "/organizefinance/report") {
      setSelectedTab(3);
    }
  }, [location.pathname]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);

    if (newValue === 0) {
      navigate("/organizefinance/accountoverview");
    } else if (newValue === 1) {
      navigate("/organizefinance/transaction");
    } else if (newValue === 2) {
      navigate("/organizefinance/budgetting");
    } else if (newValue === 3) {
      navigate("/organizefinance/report");
    }
  };

  return (
    <div>

      <div className="p-5">
        <TabPanel value={selectedTab} index={0}>
          <Accountoverview />
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          <TransactionTab />
        </TabPanel>
        <TabPanel value={selectedTab} index={2}>
          <BudgettingTab />
        </TabPanel>
        <TabPanel value={selectedTab} index={3}>
          <ReportTab />
        </TabPanel>
      </div>
    </div>
  );
};

export default Myaccount;
